"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.fetchBlogPosts = void 0;

var _API = _interopRequireDefault(require("./API"));

var _actions = require("./actions");

var _selectors = require("./selectors");

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-ui-sdk/RequestEpicDescriptor"));

var _requestEntity = _interopRequireDefault(require("settings-ui-sdk/requestEntity"));

var _reduxObservable = require("redux-observable");

var fetchBlogPosts = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.getBlogPosts,
  initiatingActionType: _actions.BlogPostsActionTypes.LOAD_BLOG_POSTS,
  requestStatusSelector: _selectors.getFetchBlogPostsRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.FetchBlogPosts
}));
exports.fetchBlogPosts = fetchBlogPosts;

var _default = (0, _reduxObservable.combineEpics)(fetchBlogPosts);

exports.default = _default;